/**
 * 購入に広告のクリック情報を残す。
 *
 * 注文は Shopify の Webhook でアプリ (app.babytale.net) に届き、アプリが
 * Meta のコンバージョン API で購入を送る。Meta が「広告を押した人の購入か」
 * を照合できるよう、ここでクリック情報をカート属性に入れておく。カート属性は
 * そのまま注文の note_attributes として Webhook に載る。
 *
 * 入れるもの:
 *   _fbc  広告のクリック ID。Meta ピクセルの Cookie (_fbc) があればそれを、
 *         無ければ着地時の URL の fbclid から同じ形 (fb.1.{時刻}.{fbclid}) で作る
 *   _fbp  ブラウザの ID。Meta ピクセルの Cookie (_fbp)
 *
 * 広告から着地したあと、別の日に LP に戻って買うこともあるので、fbclid は
 * クリック時刻と一緒に localStorage に残す (Meta のクリック後の計測期間に
 * 合わせて 28 日)。
 *
 * 計測のための処理なので、失敗しても画面や購入を妨げないよう全体を try で囲む。
 * Meta に送るかどうかはアプリの設定で決まる (ここでは送らない)。
 */
(function () {
  "use strict";

  var STORAGE_KEY = "bt_meta_click";
  var MAX_AGE_MS = 28 * 24 * 60 * 60 * 1000;
  /** 1 項目の最大長。Shopify のカート属性を異常な値で壊さないため */
  var MAX_LENGTH = 255;

  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split("; ") : [];
    for (var i = 0; i < parts.length; i++) {
      var eq = parts[i].indexOf("=");
      if (parts[i].slice(0, eq) === name) {
        return decodeURIComponent(parts[i].slice(eq + 1));
      }
    }
    return null;
  }

  /** 着地時の URL に fbclid があれば、クリック時刻と一緒に残す */
  function rememberClick() {
    var fbclid = new URL(window.location.href).searchParams.get("fbclid");
    if (!fbclid) return;
    var saved = loadClick();
    // 同じクリックで再読み込みしたときは、最初の時刻を保つ
    if (saved && saved.fbclid === fbclid) return;
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ fbclid: fbclid.slice(0, MAX_LENGTH), ts: Date.now() }),
    );
  }

  function loadClick() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var click = JSON.parse(raw);
      if (!click.fbclid || !click.ts || Date.now() - click.ts > MAX_AGE_MS) {
        return null;
      }
      return click;
    } catch (e) {
      return null;
    }
  }

  function buildAttributes() {
    var attributes = {};
    var fbc = readCookie("_fbc");
    if (!fbc) {
      var click = loadClick();
      if (click) fbc = "fb.1." + click.ts + "." + click.fbclid;
    }
    if (fbc) attributes._fbc = fbc.slice(0, MAX_LENGTH);
    var fbp = readCookie("_fbp");
    if (fbp) attributes._fbp = fbp.slice(0, MAX_LENGTH);
    return attributes;
  }

  /** カート属性に入れる。すでに同じ値が入っていれば何もしない */
  function syncCart() {
    var attributes = buildAttributes();
    var keys = Object.keys(attributes);
    if (keys.length === 0) return;

    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    fetch(root + "cart.js", { credentials: "same-origin" })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        var current = (cart && cart.attributes) || {};
        var changed = keys.some(function (k) {
          return current[k] !== attributes[k];
        });
        if (!changed) return;
        return fetch(root + "cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: attributes }),
        });
      })
      .catch(function () {
        /* 計測のための処理なので失敗しても何もしない */
      });
  }

  try {
    rememberClick();
  } catch (e) {
    /* localStorage が使えない環境 (プライベートブラウズ等) では URL だけで足りない分を諦める */
  }

  function run() {
    try {
      syncCart();
    } catch (e) {
      /* 何もしない */
    }
  }

  // Meta ピクセル (GTM 経由) が Cookie を作るのを待ってから読む
  if (document.readyState === "complete") {
    setTimeout(run, 1500);
  } else {
    window.addEventListener("load", function () {
      setTimeout(run, 1500);
    });
  }
})();
